import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import "./IntroPage.css";
import { Button } from "@veriff/genoma";
import ErrorPage from "../ErrorPage/ErrorPage";
import ExpiredPage from "../ExpiredPage/ExpiredPage";

const IntroPage = (props) => {
    const [jwtStatus, setJwtStatus] = React.useState("failed");
    const jwtBackUrl = "/api/v";

    useEffect(() => {
        let windowUrlPath = window.location.pathname;
        windowUrlPath = windowUrlPath.substring(3);
        const tokenString = `Bearer ${windowUrlPath}`;
        validateJWT(tokenString);
        window.Intercom("boot", {
            app_id: "yn2gxy8s",
        });
    }, []);

    async function validateJWT(tokenStr) {
        return await new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open("POST", jwtBackUrl, true);
            xhr.setRequestHeader("Content-Type", "application/json");
            xhr.setRequestHeader("Authorization", tokenStr);
            xhr.send();
            xhr.onload = () => {
                let tokenResp;
                if (xhr.status === 200) {
                    tokenResp = JSON.parse(xhr.responseText);
                    if (tokenResp.status === "success") {
                        setJwtStatus("done");
                        resolve(JSON.parse(xhr.responseText));
                    } else if (tokenResp.status === "failed") {
                        switch (tokenResp.status_code) {
                            case 4000:
                                setJwtStatus("expired");
                                break;
                            default:
                                setJwtStatus("failed");
                        }
                    }
                } else {
                    tokenResp = xhr.responseText;
                    setJwtStatus("failed");
                }
            };
        });
    }

    if (jwtStatus === "done") {
        return (
            <div className="intro-general">
                <img src="/logo-loop.gif" alt="veriff-logo-gif" />

                <div>
                    <h2 className="inst-title">Data upload</h2>
                    <p className="inst-desc">
                        {" "}
                        Hi 👋 Are you ready to upload your sessions? <br></br>
                        Organize your folders and files like the following illustration:
                    </p>
                </div>

                <div className="structure">
                    <div className="struct-only-folder">
                        <img alt="folder-icon" src="/icon-folder.svg" />
                        <div className="folder-name">Company_name</div>
                    </div>
                    <div className="inner-rectangle">
                        <div className="struct-only-folder">
                            <img alt="folder-icon" src="/icon-folder.svg" />
                            <div className="folder-name">sessionID01</div>
                        </div>
                        <div className="struct-file">
                            <img className="file-icon" alt="file-icon" src="/icon-file-purple.svg" />
                            <div className="folder-name">sessionID01_back.png</div>
                        </div>
                        <div className="struct-file">
                            <img className="file-icon" alt="file-icon" src="/icon-file-yellow.svg" />
                            <div className="folder-name">sessionID01_front.png</div>
                        </div>
                        <div className="struct-file">
                            <img className="file-icon" alt="file-icon" src="/icon-file-green.svg" />
                            <div className="folder-name">sessionID01_face.png</div>
                        </div>
                    </div>
                    <div className="inner-rectangle">
                        <div className="struct-only-folder">
                            <img alt="folder-icon" src="/icon-folder.svg" />
                            <div className="folder-name">sessionID02</div>
                        </div>
                        <div className="struct-file">
                            <img className="file-icon" alt="file-icon" src="/icon-file-purple.svg" />
                            <div className="folder-name">sessionID02_back.png</div>
                        </div>
                        <div className="struct-file">
                            <img className="file-icon" alt="file-icon" src="/icon-file-yellow.svg" />
                            <div className="folder-name">sessionID02_front.png</div>
                        </div>
                        <div className="struct-file">
                            <img className="file-icon" alt="file-icon" src="/icon-file-green.svg" />
                            <div className="folder-name">sessionID02_face.png</div>
                        </div>
                    </div>
                </div>
                <Button className="button-start" onClick={() => props.history.push("/upload")}>
                    Get Started
                </Button>
            </div>
        );
    } else if (jwtStatus === "failed") {
        return <ErrorPage />;
    } else if (jwtStatus === "expired") {
        return <ExpiredPage />;
    }
};

export default withRouter(IntroPage);
